/* Barlen: "Hulp nodig?" op de productpagina. Vlak voor de klik op WhatsApp komt het bericht klaar te staan, met het kleed en
   de keuze van dat moment (maat en kleur, of de maat op maat). De link zelf maakt barlen-onthul.js bij de klik; dit script
   luistert in de vangfase van window, dus eerder. Zonder dit script blijft het bericht met alleen de naam van het kleed. */
(function () {
  'use strict';
  if (window.barlenHulp) return;
  window.barlenHulp = true;

  var kort = function (v, n) { return String(v || '').replace(/\s+/g, ' ').trim().slice(0, n || 80); };
  var getal = function (v) { return /^[0-9]{2,4}$/.test(v || '') ? v : ''; };

  /* De gekozen waarde van een optie in de kleedviewer, als het adres hem (nog) niet noemt. */
  function gekozen(kv, spoor, soort) {
    var i = kv ? kv.querySelector('input[data-kv-optie="' + spoor + '"][data-kv-soort="' + soort + '"]:checked') : null;
    return i ? kort(i.value, 40) : '';
  }

  function bericht(knop) {
    var titel = kort(knop.getAttribute('data-hn-product'), 120);
    var q = new URLSearchParams(window.location.search);
    var kv = knop.closest('.kv') || document.querySelector('.kv');
    var spoor = kv ? (kv.getAttribute('data-spoor-nu') || kv.getAttribute('data-spoor') || 'std') : 'std';
    var opMaat = q.get('spoor') === 'maat' || (q.get('spoor') !== 'standaard' && spoor === 'mw');
    var delen = [];
    if (opMaat) {
      var b = getal(q.get('b')), l = getal(q.get('l')), d = getal(q.get('d'));
      var vorm = kort(q.get('vorm'), 30).toLowerCase();
      var maat = d ? 'Ø ' + d + ' cm' : (b && l ? b + ' × ' + l + ' cm' : '');
      delen.push('op maat' + (vorm || maat ? ': ' + [vorm, maat].filter(Boolean).join(' ') : ''));
    } else {
      var m = kort(q.get('maat'), 40) || gekozen(kv, 'std', 'maat');
      if (m) delen.push('maat ' + m);
    }
    var k = kort(q.get('kleur'), 40) || gekozen(kv, opMaat ? 'mw' : 'std', 'kleur');
    if (k) delen.push('kleur ' + k);
    return 'Hoi Barlen, ik heb een vraag over ' + titel + (delen.length ? ' (' + delen.join(', ') + ')' : '') + '.';
  }

  window.addEventListener('click', function (e) {
    var knop = e.target && e.target.closest ? e.target.closest('a[data-hn-product][data-bf-onthul="wa"]') : null;
    if (!knop) return;
    try { knop.setAttribute('data-bf-bericht', bericht(knop)); } catch (fout) { /* dan blijft het bericht met alleen het kleed */ }
  }, true);
})();
